import { PRODUCTS_ERROR, PRODUCTS_LOADING, PRODUCTS_SUCESS } from "./products.types";
import axios from "axios";

export const showProducts = (value) => (dispatch) => {
  dispatch({ type: PRODUCTS_LOADING });

  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/products/all`)
    .then((r) => {
      dispatch({ type: PRODUCTS_SUCESS, payload: r.data.data });
    })
    .catch(() => {
      dispatch({ type: PRODUCTS_ERROR });
    });
};
